import { calcAPCA } from 'apca-w3';

import GemMeterBaseRule from '../GemMeterBaseRule';
import { HARD_TO_READ_BUTTON } from '../../../constants/rulesConstants';

const sizeAndWeightMapper = {
  '12': [0, 0, 0, 0, 0, 0, 0, 0, 0],
  '14': [0, 0, 0, 100, 100, 90, 75, 0, 0],
  '15': [0, 0, 0, 100, 90, 75, 70, 0, 0],
  '16': [0, 0, 0, 90, 75, 70, 60, 60, 0],
  '18': [0, 0, 100, 75, 70, 60, 55, 55, 55],
  '21': [0, 0, 90, 70, 60, 55, 50, 50, 50],
  '24': [0, 0, 75, 60, 55, 50, 45, 45, 45],
  '28': [0, 100, 70, 55, 50, 45, 43, 43, 43],
  '32': [0, 90, 65, 50, 45, 45, 40, 40, 40],
  '36': [0, 75, 60, 45, 43, 40, 38, 38, 38],
  '42': [100, 70, 55, 43, 40, 38, 35, 35, 35],
  '48': [90, 60, 50, 40, 38, 35, 33, 33, 33],
  '60': [75, 55, 45, 38, 35, 33, 30, 30, 30],
  '72': [60, 50, 40, 35, 33, 30, 30, 30, 30],
  '96': [50, 45, 35, 33, 30, 30, 30, 30, 30],
}
export default class ContrastRule extends GemMeterBaseRule {
  static ruleId = HARD_TO_READ_BUTTON.id;

  static validate(selector: string) {
    const element = GemMeterBaseRule.getElement(selector);
    if (!element) {
      return false;
    }

    const elementStyle = getComputedStyle(element);
    const textColor = elementStyle.color;
    const bgrColor = elementStyle.backgroundColor;
    if (bgrColor === 'rgba(0, 0, 0, 0)') {
      return true;
    }

    const fontSize = elementStyle.fontSize ? parseFloat(elementStyle.fontSize.replace('px', '')) : 0;
    const fontWeightIndex = elementStyle.fontWeight ? parseInt(elementStyle.fontWeight.replace('00', '')) : 0;
    const apcaValue = calcAPCA(textColor, bgrColor) as number;
    const sizeAndWeightValue = ContrastRule.findSizeAndWeightValue(fontSize, fontWeightIndex);

    return ContrastRule.calculateRating(apcaValue, sizeAndWeightValue) > 0;
  }

  static calculateRating(apcaValue: number, sizeAndWeightValue: number) {
    const percentageDiff = (Math.abs(apcaValue) * 100) / sizeAndWeightValue - 100;

    if (percentageDiff >= 0) {
      return 4
    };

    const normalizedDiff = Math.floor(percentageDiff / 5) * 5;
    const rangeMap = new Map<number, number>([
      [0, 4],
      [-5, 3],
      [-10, 2],
      [-15, 1],
      [-20, 1],
      [-25, 1],
      [-30, 1],
      [-35, 1],
      [-40, 1],
      [-45, 1],
    ]);

    return rangeMap.get(normalizedDiff) ?? 0;
  }

  static findSizeAndWeightValue(fontSize: number, fontWeightIndex: number) {
    let key = '96';
    for (let size of Object.keys(sizeAndWeightMapper)) {
      if (fontSize <= parseInt(size)) {
        key = size;
        break;
      }
    }

    return sizeAndWeightMapper[key as keyof typeof sizeAndWeightMapper][fontWeightIndex - 1];
  }
}
